import { ThemeOptions } from '@mui/material/styles/createTheme';

export const typography: ThemeOptions['typography'] = {
  fontFamily: 'Raleway',
  h1: {
    fontSize: 96,
    fontWeight: 900,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontSize: 60,
    fontWeight: 800,
  },
  h3: {
    fontSize: 48,
    fontWeight: 800,
  },
  h4: {
    fontSize: 34,
    fontWeight: 700,
    letterSpacing: '0.25px',
    lineHeight: '129%',
  },
  h5: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '135%',
  },
  bodyBig: {
    fontSize: 20,
    fontWeight: 500,
    letterSpacing: '0.15px',
    lineHeight: '30px',
  },
  bodyBigSemiBold: {
    fontSize: 20,
    fontWeight: 600,
    letterSpacing: '0.15px',
    lineHeight: '30px',
  },
  bodyBigBold: {
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: '0.15px',
    lineHeight: '30px',
  },
  body1: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: '0.44px',
    lineHeight: '26px',
  },
  body1Bold: {
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '0.44px',
    lineHeight: '26px',
  },
  body2Bold: {
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: '0.25px',
    lineHeight: '20px',
  },
  subtitle1: {
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '26px',
  },
  subtitle2: {
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '22px',
  },
  subtitle2Bold: {
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: '0.1px',
    lineHeight: '22px',
  },
  button: {
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: '0.75px',
  },
  body2: {
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0.25px',
    lineHeight: '20px',
  },
  caption: {
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: '0.4px',
    lineHeight: '16px',
  },
  captionBold: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '0.4px',
    lineHeight: '16px',
  },
  overline: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '2%',
    lineHeight: '16px',
  },
};
